import { EventBroker } from "@frontend/lib/utils/event-broker";

export const EVENTS = {
    SAVED: 'SAVED',
    INIT: 'INIT',
    CLOSED: 'CLOSED',
    BATCH_INIT: 'BATCH_INIT'
}

export const translateTemplateImageEventBroker = new EventBroker();
